import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  promotions: [],
  currentShared: null,
  currentPromo: null,
  shouldUpdateTable: false,
  shouldUpdatePromotions: false,
  hasTableData: false,
  hasInActionProducts: false,
  isOpenCostDrawer: false,
  productId: null,
  inShareRedux: true,
  isLoadingPromo: false,
  // Фильтры таблицы (UI состояние) и применённые фильтры (формат для API)
  tableFilters: {
    categories: [],
    subjects: [],
    supplier_article: [],
    gross_margin: { gte: "", lte: "" },
    marginality: { gte: "", lte: "" },
    days_of_stock: { gte: "", lte: "" },
    turnover: { gte: "", lte: "" },
    discounted_retail_price: { gte: "", lte: "" },
    synthetic_abc_group_label: "",
  },
  appliedTableFilters: {},
};

const promotions = createSlice({
  name: "promotions",
  initialState,
  reducers: {
    setPromotions(state, { payload: { value } }) {
      state.promotions = value;
    },
    setCurrentShared(state, { payload: { value } }) {
      state.currentShared = value;
    },
    setCurrentPromotion(state, { payload: { value } }) {
      state.currentPromo = value;
    },
    clearPromotions(state) {
      state.promotions = [];
    },
    clearCurrentShared(state) {
      state.currentShared = null;
    },
    clearCurrentPromo(state) {
      state.currentPromo = null;
    },
    setShouldUpdateTable(state, { payload: { value } }) {
      state.shouldUpdateTable = value;
    },
    setShouldUpdatePromotions(state, { payload: { value } }) {
      state.shouldUpdatePromotions = value;
    },
    setHasTableData(state, { payload: { value } }) {
      state.hasTableData = value;
    },
    setHasInActionProducts(state, { payload: { value } }) {
      state.hasInActionProducts = value;
    },
    setIsOpenCostDrawer(state, { payload: { value } }) {
      state.isOpenCostDrawer = value;
    },
    setProductId(state, { payload: { value } }) {
      state.productId = value;
    },
    setInShareRedux(state, { payload: { value } }) {
      state.inShareRedux = value;
    },
    setIsLoadingPromo(state, { payload: { value } }) {
      state.isLoadingPromo = value;
    },
    setTableFilters(state, { payload: { value } }) {
      state.tableFilters = value;
    },
    resetTableFilters(state) {
      state.tableFilters = {
        categories: [],
        subjects: [],
        supplier_article: [],
        gross_margin: { gte: "", lte: "" },
        marginality: { gte: "", lte: "" },
        days_of_stock: { gte: "", lte: "" },
        turnover: { gte: "", lte: "" },
        discounted_retail_price: { gte: "", lte: "" },
        synthetic_abc_group_label: "",
      };
    },
    setAppliedTableFilters(state, { payload: { value } }) {
      state.appliedTableFilters = value;
    },
  },
});

export default promotions.reducer;

export const {
  setPromotions,
  setCurrentShared,
  setCurrentPromotion,
  clearPromotions,
  clearCurrentShared,
  clearCurrentPromo,
  setShouldUpdateTable,
  setShouldUpdatePromotions,
  setHasTableData,
  setHasInActionProducts,
  setIsOpenCostDrawer,
  setProductId,
  setInShareRedux,
  setIsLoadingPromo,
  setTableFilters,
  resetTableFilters,
  setAppliedTableFilters,
} = promotions.actions;
